<mat-toolbar class="stickyBar" role="heading" color="primary">
  <mat-icon>location_on</mat-icon><span class="appname"> Mc Pois </span>
  <div class="container-logo">
    <div class="logo"></div>
  </div>
  <mat-divider [vertical]="true"></mat-divider>
  <app-breadcrumb></app-breadcrumb>
  <div class="spacer"></div>
  

  <app-main-menu style="margin-top: 10px;"></app-main-menu>
</mat-toolbar>
